import {defineStore} from "pinia";
import {useUserStore} from "@/stores/user.js";
import api from "@/api.js";
import router from "@/router/index.js";
import {client} from '@/stores/client.js'
import {gregorianDate} from "@/utils/gregorianDate.js";

export const useChatGptStore = defineStore('chatGpt', {

  state: () => ({
    selectedChat: {},
    client: {},
    chatData: {},
    chatMessages: [],
    chats: [],
    filteredChats: []
  }),

  getters: {
    get_chat_data() {
      return this.chatMessages
    },
    get_chats_data() {
      return this.chats
    },

    get_chat_filtered_data() {
      return this.filteredChats
    }
  },
  actions: {
    set_chat_data(payload) {
      this.chatData = payload
    },

    set_channel_id(payload) {
      this.channelID = payload
    },

    set_chat_filtered_data(payload) {
      this.filteredChats = payload
    },
    async action_get_chat(id) {

      const userStore = useUserStore()
      const request = {
        "request": 1009,
        "subRequest": 10152,
        "account": {
          "id": userStore.getUserId,
          "credential": userStore.getCredential
        },
        "client": client,
        "chat": {
          "channel": id,
          "store": "DealHub USD",
          "storeID": "1001234905"
        }
      };
      this.loadingMessages = true
      this.set_chat_data({})
      return await api.post('', request)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then((data) => {
          if (data.response === 100) {
            this.set_chat_data(data.chat)
            this.chatMessages = []
            if (data.chat && data.chat.messages) {

              const reversedMessages = [...data.chat.messages].reverse()

              for (const a of reversedMessages) {
                let sender = "B";
                if (a.from == "DealHub") {
                  sender = "A";
                }
                this.chatMessages.push({sender: sender, message: a.message, t: a.time})
              }
            }
            this.loadingMessages = false
            return true
          } else if (data.response === -100002) {
            userStore.resetUser('your credential is expired')
            router.push({name: 'Login'})
          } else {
            this.errorMessage = data.message
            return false
          }
        })
    },
    async action_get_data(userName) {
      const userStore = useUserStore()
      const request = {
        "request": 1009,
        "subRequest": 2067,
        "account": {
          "id": userStore.getUserId,
          "credential": userStore.getCredential
        },
        "client": client,
        "chat": {
          "contact": userName
        }
      };
      this.loadingMessages = true
      return await api.post('', request)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then((data) => {

          if (data.response === 100) {
            this.set_chat_filtered_data(data.chats)
            return true
          } else if (data.response === -100002) {
            userStore.resetUser('your credential is expired')
            router.push({name: 'Login'})
          } else {
            this.errorMessage = data.message
            return false
          }
        })
    },
  }
});
